import { Expose } from "class-transformer";
import { IsBoolean, IsNumber, IsString } from "class-validator";

export class BankStatementMatch {
  @Expose()
  @IsNumber()
  amountInReference!: number; // 4052;
  @Expose()
  @IsNumber()
  bankStatementItemAmount!: number; // 4053;
  @Expose()
  @IsNumber()
  bankStatementItemAmountInCurrency!: number; // 4053;
  @Expose()
  @IsNumber()
  bankStatementItemAmountLeft!: number; // 4052;
  @Expose()
  @IsNumber()
  bankStatementItemAmountLeftInCurrency!: number; // 4052;
  @Expose()
  @IsString()
  bankStatementItemCurrency!: string; // "PLN";
  @Expose()
  @IsString()
  bankStatementItemExchangeDate!: string; // "3/8/2022";
  @Expose()
  @IsNumber()
  bankStatementItemExchangeRate!: number; // 1;
  @Expose()
  @IsNumber()
  bankStatementItemId!: number; // 684882;
  @Expose()
  @IsNumber()
  bankStatementItemLeftToPay!: number; // 0;
  @Expose()
  @IsNumber()
  bankStatementItemToPayInCurrency!: number; // 0;
  @Expose()
  @IsBoolean()
  isExchangeDifference!: boolean; // false;
  @Expose()
  @IsString()
  pairCurrency!: string; // "PLN";
  @Expose()
  @IsNumber()
  paymentAmount!: number; // 4052;
  @Expose()
  @IsNumber()
  paymentAmountInCurrency!: number; // 4052;
  @Expose()
  @IsNumber()
  referenceAmount!: number; // 4052;
  @Expose()
  @IsString()
  referenceCurrency!: string; // "PLN";
  @Expose()
  @IsString()
  referenceExchangeDate!: string; // "3/16/2022";
  @Expose()
  @IsNumber()
  referenceExchangeRate!: number;
  @Expose()
  @IsNumber()
  referenceGross!: number; // 10187.41;
  @Expose()
  @IsNumber()
  referenceGrossInCurrency!: number; // 10187.41;
  @Expose()
  @IsNumber()
  referenceLeftToPay!: number; // 6135.41;
  @Expose()
  @IsNumber()
  referenceLeftToPayInCurrency!: number; //6135.41;
  @Expose()
  @IsString()
  referenceNumber!: string; // "1846/03/2022/RZE";
  @Expose()
  @IsNumber()
  referencePaymentAmount!: number; // 0;
  @Expose()
  @IsNumber()
  referencePaymentAmountInCurrency!: number; // 0;
}

export class BankStatementMatchReservation extends BankStatementMatch {
  @Expose()
  @IsNumber()
  bookingItemId!: number;
}

export class BankStatementMatchDocument extends BankStatementMatch {
  @Expose()
  @IsString()
  documentId!: string; // "41765685-987b-47f7-a899-cc337acf3ffa";
}
